(() => {
  'use strict';
  if (window.cubedartsWishlistLoaded) return;
  window.cubedartsWishlistLoaded = true;
  const configNode = document.getElementById('cubedarts-wishlist-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const text = config.strings;
  const KEY = 'shop_wishlist_v1';
  const LIMIT = 100;
  const cache = new Map();
  const pending = new Map();
  let generation = 0;
  let lastFocus = null;
  const valid = h => typeof h === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(h);
  const normalize = list => Array.isArray(list) ? [...new Set(list.filter(valid))].slice(0, LIMIT) : [];
  const get = () => {
    try { return normalize(JSON.parse(localStorage.getItem(KEY))); }
    catch { return []; }
  };
  const announce = message => {
    const node = document.getElementById('wishlist-announcement');
    if (node) node.textContent = message;
  };
  const save = list => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); }
    catch { announce(text.storage_error); return false; }
    document.dispatchEvent(new CustomEvent('wishlist:change', {detail: list}));
    return true;
  };
  function syncButtons() {
    const list = get();
    document.querySelectorAll('button[data-wishlist-handle]').forEach(button => {
      const active = list.includes(button.dataset.wishlistHandle);
      if (button.hasAttribute('data-wishlist-remove')) return;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? text.remove : text.add);
      const label = button.querySelector('[data-wishlist-label]');
      if (label && label.textContent !== (active ? text.saved : text.add)) label.textContent = active ? text.saved : text.add;
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(node => {
      if (node.textContent !== String(list.length)) node.textContent = String(list.length);
      node.hidden = list.length === 0;
    });
  }
  const create = (tag, cls, label) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (label) node.textContent = label;
    return node;
  };
  function productData(handle) {
    if (cache.has(handle)) return Promise.resolve(cache.get(handle));
    if (pending.has(handle)) return pending.get(handle);
    const request = fetch(`${config.root}products/${encodeURIComponent(handle)}.js`, {headers: {'Accept':'application/json'}})
      .then(async response => {
        if (response.status === 404 || response.status === 410) return {handle, missing:true};
        if (!response.ok) throw new Error('load');
        const product = await response.json();
        if (!valid(product.handle) || typeof product.title !== 'string' || !Number.isFinite(product.price)) throw new Error('data');
        return product;
      })
      .then(product => {cache.set(handle, product); return product;})
      .finally(() => pending.delete(handle));
    pending.set(handle, request);
    return request;
  }
  function removeButton(handle, index) {
    const button = create('button', 'wishlist-remove', text.remove);
    button.type = 'button';
    button.dataset.wishlistHandle = handle;
    button.dataset.wishlistRemove = '';
    button.dataset.wishlistIndex = String(index);
    return button;
  }
  function card(product, index) {
    const item = create('article', 'wishlist-item');
    if (product.missing) {
      item.append(create('p', '', text.unavailable), removeButton(product.handle, index));
      return item;
    }
    const link = create('a');
    link.href = `${config.root}products/${encodeURIComponent(product.handle)}`;
    if (product.featured_image) {
      try {
        const imageURL = new URL(product.featured_image, location.origin);
        if (imageURL.protocol === 'https:' && (imageURL.hostname === location.hostname || imageURL.hostname === 'cdn.shopify.com' || imageURL.hostname.endsWith('.shopify.com'))) {
          imageURL.searchParams.set('width', '500');
          const img = create('img');
          img.src = imageURL.href; img.alt = product.title; img.width = 500; img.height = 500; img.loading = 'lazy';
          link.append(img);
        }
      } catch {}
    }
    link.append(create('h2', '', product.title));
    const currency = window.Shopify?.currency?.active || config.currency || 'EUR';
    let price;
    try {price = new Intl.NumberFormat(config.locale, {style:'currency',currency}).format(product.price / 100);}
    catch {price = `${(product.price / 100).toFixed(2)} ${currency}`;}
    const view = create('a', 'btn btn--secondary', text.view);
    view.href = link.href;
    item.append(link, create('p', '', price), view, removeButton(product.handle, index));
    return item;
  }
  async function renderPage() {
    const root = document.getElementById('wishlist-items');
    if (!root) return;
    const token = ++generation;
    const list = get();
    root.setAttribute('aria-busy', 'true');
    if (!list.length) {
      const state = create('div', 'wishlist-state');
      const browse = create('a', 'btn btn--primary', text.browse);
      browse.href = `${config.root}collections/all`;
      state.append(create('p', '', text.empty), browse);
      root.replaceChildren(state);
      root.setAttribute('aria-busy', 'false');
      if (lastFocus !== null) {browse.focus(); lastFocus = null;}
      return;
    }
    if (!root.children.length) root.append(create('p', 'wishlist-state', text.loading));
    const results = new Array(list.length);
    let next = 0;
    async function worker() {
      while (next < list.length) {
        const index = next++;
        try {results[index] = await productData(list[index]);}
        catch {results[index] = {failed:true};}
      }
    }
    await Promise.all(Array.from({length:Math.min(4, list.length)}, worker));
    if (token !== generation || !root.isConnected) return;
    const fragment = document.createDocumentFragment();
    results.forEach((product, index) => {if (!product.failed) fragment.append(card(product, index));});
    if (results.some(product => product.failed)) {
      const state = create('div', 'wishlist-state');
      const retry = create('button', 'btn btn--secondary', text.retry);
      retry.type = 'button'; retry.addEventListener('click', renderPage);
      state.append(create('p', '', text.load_error), retry); fragment.append(state);
    }
    root.replaceChildren(fragment);
    root.setAttribute('aria-busy', 'false');
    if (lastFocus !== null) {
      const buttons = root.querySelectorAll('[data-wishlist-remove]');
      buttons[Math.min(lastFocus, buttons.length - 1)]?.focus();
      lastFocus = null;
    }
    syncButtons();
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target.closest('button[data-wishlist-handle]') : null;
    if (!target) return;
    event.preventDefault();
    const handle = target.dataset.wishlistHandle;
    if (!valid(handle)) return;
    const list = get();
    const index = list.indexOf(handle);
    const removing = index !== -1;
    if (!removing && target.hasAttribute('data-wishlist-remove')) return;
    if (!removing && list.length >= LIMIT) {announce(text.limit); return;}
    if (target.hasAttribute('data-wishlist-remove')) lastFocus = Number(target.dataset.wishlistIndex);
    if (removing) list.splice(index,1); else list.push(handle);
    if (save(list)) announce(removing ? text.removed : text.added);
  });
  document.addEventListener('wishlist:change', () => {syncButtons(); renderPage();});
  window.addEventListener('storage', event => {if (event.key === KEY || event.key === null) {syncButtons(); renderPage();}});
  window.addEventListener('pageshow', () => {syncButtons(); renderPage();});
  document.addEventListener('shopify:section:load', () => {syncButtons(); renderPage();});
  function init() {
    syncButtons(); renderPage();
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node instanceof Element && (node.matches('[data-wishlist-handle], [data-wishlist-count]') || node.querySelector('[data-wishlist-handle], [data-wishlist-count]'))))) syncButtons();
    }).observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
